import React, { FC, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ReportIcon } from "src/components/ui-icons/sidebar";
import { useFiltersContext } from "src/contexts/FilterContext";
import useGetBreadCrumbs from "src/hooks/useGetBreadCrumbs";
import { FavoriteButtonFilters } from "./RegisterDocuments/FavoriteButtonFilters";
import { FavoriteFiltersList } from "./RegisterDocuments/FavoriteFiltersList";
import RegisterDocumentsFilters from "./RegisterDocuments/RegisterDocumentsFilters";

interface IProps {
  reportsCrumbs: string[];
  Icon?: any;
  path?: any;
}

const ReportsBreadCrumbs: FC<IProps> = ({ reportsCrumbs, Icon, path }) => {
  const { filters } = useFiltersContext();
  const { breadcrumbs, length: breadcrumbsLength } = useGetBreadCrumbs(filters);
  const { id } = useParams();
  const { reportID } = useParams();

  return (
    <div className="px-7.5 py-[26px] border-b border-[#DFE4EA]-500 flex justify-between ">
      <div className="flex items-center gap-2 hover:cursor-pointer w-[50%]">
        <span>
          <ReportIcon />
        </span>
        <Link to={`/dashboard/${id}/reports`}>Отчеты</Link>
        {!!reportsCrumbs.length && (
          <span className="text-body-color">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                fill={"#637381"}
              />
            </svg>
          </span>
        )}

        {Icon ? <Icon width="16" /> : null}
        <span className="block min-w-fit">{reportsCrumbs}</span>

        {path ? (
          <div className="flex items-center gap-2 ">
            <span className="text-body-color">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                  fill={"#637381"}
                />
              </svg>
            </span>
            <span className="block min-w-fit"> {path}</span>
          </div>
        ) : null}

        {reportID && reportID === "1" ? (
          <div className="w-full flex items-center gap-2">
            <span className="text-body-color">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                  fill={"#637381"}
                />
              </svg>
            </span>
            {!breadcrumbsLength && reportID === "1" && (
              <div className="inline-flex items-center" aria-current="page">
                <div className="inline-flex items-center space-x-2 text-base font-medium">
                  <span>Фильтры не выбраны</span>
                </div>
              </div>
            )}
            <div className="flex items-center grow" aria-current="page">
              <div className="flex items-center w-full text-base font-medium">{breadcrumbs}</div>
            </div>
          </div>
        ) : null}
      </div>
      <RegisterDocumentsFilters breadcrumbsLength={breadcrumbsLength} filters={filters} reportID={reportID} />
    </div>
  );
};

export default ReportsBreadCrumbs;
